import { render } from "./HeroiconsSolidBookmark.vue?vue&type=template&id=20ebe4f8"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBookmark.vue"]])

export default __exports__